export default {
    blue_1: '#3726A6',
    blue_2: '#4A44F2',
    yellow_3: '#F2E635',
    golden_4: '#F2BE22',
    red_5: '#F20505',
};
